import React from 'react';
import { CTAButton } from './CTAButton';
export function ProgramDetails() {
  return <div className="w-full my-12 p-8 bg-gradient-to-r from-teal-100 to-purple-100 rounded-xl shadow-lg" data-id="element-464">
      <div className="max-w-3xl mx-auto" data-id="element-465">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-466">
          What You'll Get Inside Unfreeze
        </h2>
        <h3 className="text-xl font-bold text-gray-800 mb-6 text-center" data-id="element-467">
          A full-body guided reset designed for safety, softness, and
          re-connection
        </h3>
        <div className="space-y-6 mt-8" data-id="element-468">
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-469">
            <p className="font-bold text-purple-800 mb-3" data-id="element-470">
              ✅ 4 Guided Video Practices
            </p>
            <p className="text-gray-700 mb-3" data-id="element-471">
              Each week, you'll explore 2 deeply soothing, science-backed
              practices—led by therapist and expressive healing expert Jolena
              Nicol. These include:
            </p>
            <ul className="list-disc pl-6 mb-2 text-gray-700" data-id="element-472">
              <li className="mb-2" data-id="element-473">
                <span className="font-medium" data-id="element-474">
                  Movement + Mark-Making Rituals
                </span>{' '}
                To help reconnect your body with sensation and motion
              </li>
              <li className="mb-2" data-id="element-475">
                <span className="font-medium" data-id="element-476">Voice + Sound Exploration</span>{' '}
                To stimulate the vagus nerve and awaken frozen emotional
                pathways
              </li>
              <li className="mb-2" data-id="element-477">
                <span className="font-medium" data-id="element-478">Symbolic Art + Texture Work</span>{' '}
                To express internal states that words can't access—and begin
                releasing them gently
              </li>
            </ul>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-479">
            <p className="font-bold text-teal-800 mb-3" data-id="element-480">
              ✅ Printable Workbook
            </p>
            <p className="text-gray-700" data-id="element-481">
              Your full-color companion for every practice. Includes reflection
              prompts, body maps, expressive charts, and gentle tracking tools
              to help you notice shifts over time. (You can also just follow
              along digitally.)
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-482">
            <p className="font-bold text-purple-800 mb-3" data-id="element-483">
              ✅ 2 Live Community Healing Sessions This Month
            </p>
            <p className="text-gray-700" data-id="element-484">
              Optional live classes to drop in, connect, and practice in
              community. You'll be guided through a group process to anchor your
              nervous system and feel less alone in your healing.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-485">
            <p className="font-bold text-teal-800 mb-3" data-id="element-486">✅ Lifetime Access</p>
            <p className="text-gray-700" data-id="element-487">
              No rush. No deadlines. Come back to this work again and
              again—especially when you feel yourself slipping into numbness or
              shutdown.
            </p>
          </div>
        </div>
        <div className="mt-10 flex justify-center" data-id="element-488">
          <CTAButton text="Start Program" href="#pricing" scarcity="Enrollment open for a limited time" data-id="element-489" />
        </div>
        <div className="mt-10 bg-white p-6 rounded-lg shadow-md border border-gray-200" data-id="element-490">
          <div className="flex items-center mb-2" data-id="element-491">
            <div className="w-12 h-12 rounded-full bg-gray-200 mr-3 flex items-center justify-center text-lg font-bold" data-id="element-492">
              C
            </div>
            <div data-id="element-493">
              <h4 className="font-semibold" data-id="element-494">Cynthia D., 58</h4>
              <div className="flex items-center text-gray-500 text-sm" data-id="element-495">
                <span className="mx-2" data-id="element-496">•</span>
                <span data-id="element-497">Verified client</span>
              </div>
            </div>
          </div>
          <div className="flex mb-2" data-id="element-498">
            {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-5 h-5 text-green-500 fill-current" viewBox="0 0 20 20" data-id="element-499">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-500" />
              </svg>)}
          </div>
          <h3 className="font-bold text-lg mb-2" data-id="element-501">
            "Before this, I hadn't cried in over 12 years. I wasn't trying to
            hold it in—I just couldn't access anything. I felt like a walking
            shell."
          </h3>
          <p className="text-gray-700" data-id="element-502">
            Most programs I've tried made me feel worse because I couldn't 'go
            deep' or 'release emotions' like they told me to. This was the first
            thing that didn't ask me to feel before I was ready. I just showed
            up. I scribbled. I made sounds that didn't make sense. And something
            shifted. One night in Week 3, I started crying—not a breakdown, just
            a soft, steady release. I didn't even realize how much was living
            inside me until it started to melt.
          </p>
        </div>
      </div>
    </div>;
}